import * as React from 'react';
import { Checkbox } from '@cian/ui-kit/checkbox';
import * as styles from './DealRentTrap.css';
import { Field, ErrorMessage } from 'formik';
import { Link } from '@cian/link-component';

interface IDealRentTrapOfertaProps {
  ofertaUrl?: string;
}

export const DealRentTrapOferta: React.FC<IDealRentTrapOfertaProps> = ({ ofertaUrl }) => {
  return (
    <div className={styles['rules-wrapper']}>
      <div className={styles['rules-text']}>
        <Field name="isTermsAccepted" as={Checkbox} label="" />
        &nbsp;&nbsp;Принимаю условия{' '}
        <Link href={ofertaUrl} target="_blank">
          Оферты
        </Link>
      </div>
      <ErrorMessage component="div" className={styles['error']} name="isTermsAccepted" />
    </div>
  );
};
